module.exports = __webpack_public_path__ + "static/img/personActive.dd3f4bd8.svg";